module.exports = __webpack_public_path__ + "img/av177.20a96a18.png";